import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad645150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-hidden relative p-3 w-64 text-sm dark:text-white bg-white dark:bg-gray-800 rounded dark:border-gray-850 shadow-lg" }
const _hoisted_2 = { class: "group justify-between" }
const _hoisted_3 = { class: "flex items-center mb-1 font-semibold" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "message" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "mb-1 font-semibold title" }
const _hoisted_8 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalCloseIcon = _resolveComponent("BalCloseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.notification.transactionMetadata)
        ? (_openBlock(), _createBlock(_component_BalLink, {
            key: 0,
            href: _ctx.notification.transactionMetadata.explorerLink,
            external: "",
            noStyle: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.notification.title), 1),
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm",
                  class: "ml-1 text-gray-400 group-hover:text-pink-500 dark:text-gray-600 transition-colors"
                })
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.notification.message), 1)
            ]),
            _: 1
          }, 8, ["href"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.notification.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.notification.message), 1)
          ])),
      _createVNode(_component_BalCloseIcon, {
        class: "absolute top-3 right-2 flex-shrink-0 text-black dark:text-white cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeNotification()))
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.progressClasses),
      style: _normalizeStyle({ width: `${(_ctx.progress * 100).toFixed(0)}%` })
    }, null, 6)
  ]))
}